/* eslint-disable max-lines */
import styled from 'styled-components';
import Paper from '@base/Paper/Paper';
import TextField from '@base/TextField/TextField';
import { breakpoints } from '@styles/index';
import NumberField from '@base/NumberField/NumberField';
import Checkbox from '@material-ui/core/Checkbox';

export const Img = styled.img`
  user-drag: none;
  user-select: none;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: 16px;
`;

export const StyledHeader = styled.header`
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  height: 72px;
  z-index: 1000;
  box-shadow: 0px 8px 16px rgba(221, 230, 237, 0.4);
  width: 100%;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    height: 56px;
  }
`;

export const HeaderContainer = styled.nav`
  width: 1136px;
  margin: auto;
  height: 72px;
  display: flex;
  align-items: center;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 728px;
    height: 56px;
    padding: 0 16px;
  }
`;

export const Logo = styled(Img)`
  height: 24px;
  width: 130px;
`;

export const LeadGenContainer = styled.main`
  background: linear-gradient(180deg, #f2f7fa 0%, #ffffff 100%);
  position: relative;
  grid-column: 1/25;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    padding: 0 16px 40px;
    display: block;
  }
`;

export const Illo = styled(Img)`
  width: 112px;
  height: 78px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    position: absolute;
    right: 0;
    top: 24px;
    margin-right: -16px;
  }
`;

export const LeadGenCoverContainer = styled.section`
  display: grid;
  grid-column: span 24;
`;

export const LeadGenCoverContent = styled.div`
  position: relative;
  max-width: 294px;
  grid-column: 3/12;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    max-width: 360px;
  }
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: 1/11;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-top: 0px;
    max-width: 100%;
    width: 100%;
  }
`;

export const LeadGenWrapper = styled(Grid)`
  grid-column: span 24;
  padding: 80px 0;
  align-items: center;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    padding: 64px 0;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: flex;
    column-gap: 0;
    flex-direction: column;
    padding: ${({ $form }) => ($form ? '0' : '0 16px 40px')};
    align-items: flex-start;
    background: linear-gradient(180deg, #f2f7fa 0%, #ffffff 100%);
  }
`;

export const LeadGenContent = styled.div`
  width: 1136px;
  margin: auto;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 728px;
  }
`;

const H1 = styled.h1`
  color: #3c4852;
  margin: 0;
`;

const P = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: #3c4852;
`;

export const Title = styled.h1`
  margin: 0;
  max-width: 320px;
  margin-top: 48px;
  font-size: 40px;
  line-height: 48px;
  color: #3c4852;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 16px;
  }
  @media only screen and (max-width: ${breakpoints.tablet}) {
    margin-bottom: 12px;
    font-size: 32px;
    line-height: 38.4px;
    max-width: 260px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 28px;
    margin-bottom: 0;
    margin-top: 56px;
    line-height: 33.6px;
    max-width: 70%;
  }
`;

export const SubTitle = styled(P)`
  @media only screen and (min-width: ${breakpoints.tablet}) {
    max-width: 360px;
    font-size: 20px;
    line-height: 30px;
  }
  @media only screen and (max-width: ${breakpoints.tablet}) {
    max-width: 280px;
  }
`;

export const StyledPaper = styled(Paper)`
  border: 1px solid #f0f4f7;
  box-shadow: 0px 8px 16px rgba(221, 230, 237, 0.4);
  padding: 24px 16px;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    max-width: 464px;
    padding: 32px 24px;
    grid-column: 13/23;
    margin: 0px;
  }
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: 12/25;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-top: 40px;
    margin-bottom: 0;
  }
`;

export const ClassTitle = styled(H1)`
  font-size: 20px;
  line-height: 24px;
  margin-bottom: ${({ $subTitle }) => ($subTitle ? '2px' : '0px')};
`;

export const ClassSubTitle = styled.h3`
  font-size: 12px;
  line-height: 18px;
  color: #ffad3b;
  margin-left: 4px;
  margin-bottom: 0;
`;

export const Fire = styled(Img)`
  width: 14px;
  height: 14px;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin-top: 12px;
  font-size: 14px;
  line-height: 50%;
  &.MuiOutlinedInput-root {
    width: 100%;
    height: 48px;
    .MuiOutlinedInput-input {
      width: 100%;
      padding: 16px 14px;
    }
  }
`;

export const StyledNumberField = styled(NumberField)`
  width: 100%;
  margin-top: 12px;
  font-size: 14px;
  line-height: 50%;
  &.MuiOutlinedInput-root {
    width: 100%;
    height: 48px;
    .MuiOutlinedInput-input {
      width: 100%;
      padding: 16px 14px;
    }
  }
`;

export const FormContainer = styled.form`
  margin-top: ${({ $subTitle }) => ($subTitle ? '16px' : '32px')};
  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 24px;
    & > div:nth-child(1) {
      margin: 0;
    }
  }
`;

export const ChooseClass = styled(SubTitle)`
  margin-top: 12px;
  font-size: 14px;
  line-height: 21px;
  max-width: 100%;
  padding-left: 8px;
`;

export const Classes = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 8px;
  row-gap: 8px;
  margin-top: 12px;
  margin-bottom: 24px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const Class = styled.button`
  height: 48px;
  border-radius: 4px;
  border: 1px solid;
  background: transparent;
  border-color: ${({ $selectedClass }) =>
    $selectedClass ? '#08bd80' : '#dde6ed'};
  color: ${({ $selectedClass }) => ($selectedClass ? '#08bd80' : '#94a8b3')};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  cursor: pointer;
`;

export const BookClassButon = styled.button`
  background-color: #08bd80;
  height: 46px;
  color: #fff;
  line-height: 14px;
  border: none;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
  display: ${({ $display }) => ($display === 'sm' ? 'none;' : 'block')};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    height: 48px;
    font-size: 14px;
    line-height: 14px;
    width: 100%;
  }
  @media only screen and (min-width: ${breakpoints.tablet}) {
    ${({ height }) =>
      height === 'sm'
        ? '`height:48px;font-size:14px;line-height:14px;width:100%;`'
        : 'height:60px;font-size:20px;line-height:24px;width:192px;'}
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: ${({ $display }) => ($display === 'md' ? 'none' : 'block')};
    height: 46px;
    width: 100%;
  }
`;

export const AcceptTerms = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const TermsBox = styled(Checkbox)`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  cursor: pointer;
  &.MuiIconButton-root {
    .MuiIconButton-label {
      input {
        top: 0;
        left: 0;
        cursor: inherit;
        height: 100%;
        margin: 0;
        opacity: 0;
        padding: 0;
        z-index: 1;
        position: absolute;
      }
    }
    svg.MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  }
`;

export const TermsContent = styled.p`
  font-size: 10px;
  line-height: 15px;
  font-weight: 600p;
`;

export const AboutContainer = styled.section`
  grid-column: span 24;
  padding-top: 80px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 728px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    padding-top: 0;
    width: 100%;
    background: linear-gradient(180deg, #ffffff 0%, #f1f9ff 100%), #c4c4c4;
  }
`;

export const AboutSheild = styled(Grid)`
  overflow: hidden;
  padding: 40px 0px;
  background: linear-gradient(180deg, #ffffff 0%, #f1f9ff 100%), #c4c4c4;
  position: relative;
  grid-column: 3/23;
  border-radius: 8px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: flex;
    flex-direction: column;
    padding: 40px 16px;
    background: transparent;
    border-radius: 0;
    width: 100%;
  }
`;

export const AboutWrapper = styled.div`
  @media only screen and (min-width: ${breakpoints.tablet}) {
    display: grid;
    grid-template-columns: repeat(24, minmax(0, 1fr));
    grid-column-gap: 16px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const About = styled.div`
  grid-column: 3/13;
`;

export const AboutTitle = styled(ClassTitle)`
  margin-bottom: 24px;
  font-size: 32px;
  line-height: 38.4px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    font-size: 24px;
    line-height: 28.8px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 16px;
  }
`;

export const AboutContentGroup = styled.div`
  grid-column: 3/17;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 12px;
  row-gap: 12px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: 3/18;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    column-gap: 0;
    row-gap: 8px;
  }
`;

export const AboutSubTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const AboutContent = styled(SubTitle)`
  font-weight: 600;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0px;
  }
`;

export const AboutContentImg = styled(Img)`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

export const AboutImage = styled(Img)`
  position: absolute;
  bottom: 0;
  right: 0;
  @media only screen and (max-width: 330px) {
    width: 120px;
    z-index: -1;
  }
`;

export const FooterContainer = styled(Grid)`
  grid-column: span 24;
  margin: 180px 0 160px 0;
  align-items: center;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 728px;
    padding: 96px 0px;
    margin: 0 auto;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 80px;
    margin-bottom: 48px;
    align-items: flex-start;
    width: 100%;
  }
`;

export const FooterTitle = styled(ClassTitle)`
  margin-bottom: 16px;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 32px;
    line-height: 38.4px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-bottom: 8px;
  }
`;

export const FooterSubTitle = styled(P)`
  max-width: 318px;
  margin-bottom: 24px;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 20px;
    line-height: 30px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-bottom: 24px;
  }
`;

export const FooterCardTitle = styled(P)`
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 8px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 4px;
  }
`;

export const FooterContent = styled.div`
  grid-column: 10/25;
  display: flex;
  height: 572px;
  flex-flow: column wrap;
  justify-content: center;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: 12/25;
    align-items: flex-end;
    height: 342px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    height: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 8px;
    margin-bottom: 24px;
    width: 100%;
    row-gap: 8px;
  }
`;

export const FooterCard = styled(Paper)`
  box-shadow: 0px 16px 32px rgba(221, 230, 237, 0.4);
  overflow: hidden;
  position: relative;
  padding: 20px;
  width: 320px;
  height: 180px;
  display: inline-block;
  margin-bottom: ${({ $id }) => ($id === 2 ? 0 : '16px')};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 170px;
    height: 100px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    height: 100px;
    margin-bottom: 0px;
    width: 100%;
    ${({ $id }) => ($id === 2 ? 'display:none' : '')}
  }
`;

export const FooterImage = styled(Img)`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 62px;
  height: 40px;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    width: 140px;
    height: 90px;
  }
`;

export const FooterCardCover = styled.div``;

export const FooterCardDesc = styled.h4`
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
  display: inline-block;
  margin-right: 0;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    font-size: 20px;
    line-height: 30px;
  }
`;
export const FooterCardCount = styled(FooterCardDesc)`
  color: #08bd80;
`;

export const FooterCover = styled.div`
  grid-column: 1/8;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: 1/10;
  }
`;

export const BookAClassForm = styled.div`
  display: ${({ $display }) => ($display ? 'block' : 'none')};
`;
export const RequeestOtpForm = styled.div`
  display: ${({ $display }) => ($display ? 'block' : 'none')};
  height: 291px;
`;

export const SuccessFulCover = styled(Paper)`
  grid-column: 6/20;
  position: relative;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '64px' : '32px')};
  padding-bottom: 0;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: span 24;
    padding: 0;
    display: block;
  }
`;
export const SuccessFulContent = styled.div`
  grid-column: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '6/20' : 'span 24')};
  text-align: center;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: span 24;
    padding: 0px 16px 0;
  }
`;

export const SuccessMessageTitle = styled.h1`
  color: #08bd80;
  font-size: 24px;
  line-height: 28.8px;
  margin-bottom: 8px;
`;

export const SuccessMessageSubTitle = styled(P)`
  font-weight: 400;
  text-align: center;
  padding-bottom: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '64px' : '32px')};
`;

export const Download = styled(Paper)`
  grid-column: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '6/20' : 'span 24')};
  position: relative;
  border-radius: 0px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: ${({ $isLeadGenForm }) =>
    $isLeadGenForm ? '40px 92px' : '32px 84px'};
  ${({ $isLeadGenForm }) =>
    $isLeadGenForm
      ? ''
      : `display: block;
    text-align: center;
    place-items: center;
    grid-template-columns: repeat(12,1fr);
    column-gap: 16px;`}
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: span 24;
    box-shadow: none;
    padding: 48px 16px 40px;
    display: ${({ $isLeadGenForm }) => ($isLeadGenForm ? 'grid' : 'block')};
    background: ${({ $isLeadGenForm }) =>
      $isLeadGenForm
        ? 'linear-gradient(180deg, #f2f7fa 0%, #ffffff 100%)'
        : '#fff'};
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: block;
    text-align: center;
    background: ${({ $isLeadGenForm }) => ($isLeadGenForm ? 'none' : '#fff')};
    ${({ $isLeadGenForm }) => ($isLeadGenForm ? '' : 'padding: 48px 32px 40px')}
  }
`;

export const DownloadCover = styled.div`
  grid-column: 3/22;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    grid-column: 4/13;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: grid;
    place-items: center;
  }
`;
export const DownloadHeader = styled.p`
  font-size: 10px;
  line-height: 10px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #627984;
`;
export const DownloadTitle = styled(H1)`
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 4px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-top: 0;
  }
`;
export const DownloadSubTitle = styled(P)`
  font-weight: 400;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    text-align: center;
  }
`;

export const PlayStoreIcon = styled.a`
  color: transparent;
  cursor: pointer;
  display: ${({ type, $isLeadGenForm }) =>
    type === 'appleStore' && $isLeadGenForm ? 'none' : 'block'};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-top: 40px;
    display: block;
  }
`;

export const DownloadContent = styled.div`
  grid-column: 14/25;
  margin-top: 16px;
  ${({ $isLeadGenForm }) => ($isLeadGenForm ? '' : 'display:grid;')}
  @media only screen and (max-width: ${breakpoints.tablet}) {
    ${({ $isLeadGenForm }) =>
      $isLeadGenForm ? '' : 'grid-template-columns:1fr;'}
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    place-items: center;
    margin-top: 0;
  }
`;

export const AppImage = styled(Img)`
  width: 248px;
  height: 196px;
  margin-top: 24px;
  @media only screen and (min-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

export const BookAClassContainer = styled.div`
  @media only screen and (min-width: ${breakpoints.mobile}) {
    grid-column: 13/25;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const ConfettiContainer = styled.div`
  height: 150px;
  position: relative;
  margin: auto;
  top: -8px;
`;

export const Confetti = styled(Img)`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  height: 150px;
`;

export const Tick = styled(Img)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
  width: 56px;
  height: 56px;
`;

export const TermsLink = styled.a`
  text-decoration: none;
  color: #3c4852;
  cursor: pointer;
`;

export const Divider = styled.div`
  position: absolute;
  top: 0;
  height: 10px;
  ${({ $isLeadGenForm }) =>
    $isLeadGenForm
      ? 'width: 100%;left: 0;'
      : 'width: calc(100% - 64px);left: 32px;'}
  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.08);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    display: ${({ $isLeadGenForm }) => ($isLeadGenForm ? 'none' : 'block')};
    ${({ $isLeadGenForm }) =>
      $isLeadGenForm ? '' : 'width: calc(100% - 32px);left: 16px;'}
  }
`;
